import React, { useState } from "react";
import { Title } from "../../components/Title";
// import { Link } from "../../components/Link";
import { Link } from "../../components/LinkIcon";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { ConsultFormModal } from "../../components/CommonFormModal";

export const PriceQuestion = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="price-question">
      <Title title={t("price.question.title")}>
        {t("price.question.subtitle")}

        <Link
          onClick={() => {
            setVisible(true);
          }}
        >
          {t("price.question.extra")}
        </Link>
      </Title>
      <ConsultFormModal {...{ visible, setVisible }} />
      <div className="question-list">
        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {t("price.question.item-one.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-one.descript")}
              <a
                href="https://blog.authing.cn/blog/15"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("price.question.item-one.link")}
              </a>
            </div>
          </div>
        </div>

        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {t("price.question.item-two.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-two.descript")}
            </div>
          </div>
        </div>

        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {" "}
              {t("price.question.item-three.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-three.descript")}
            </div>
          </div>
        </div>

        <div className="item">
          <div className="left">
            <i className="icon authing-icon authing-wenti"></i>
          </div>
          <div className="right">
            <div className="question-title">
              {t("price.question.item-four.title")}
            </div>
            <div className="question-content">
              {t("price.question.item-four.other")}
              <ul>
                <li>{t("price.question.item-four.descript-one")}</li>
                <li>{t("price.question.item-four.descript-two")}</li>
                <li>{t("price.question.item-four.descript-three")}</li>
                <li>{t("price.question.item-four.descript-four")}</li>
              </ul>
              <a
                href="https://docs.authing.cn/v2"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("price.question.item-four.link")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
